import { Link } from 'react-router-dom'

/**
 * Shown when a user without site-admin rights opens an /admin/* page (mirrors
 * the league cluster's NotLeagueManager). The server enforces 401/403
 * independently — this guard is UX, not security.
 */
export function NotSiteAdmin() {
  return (
    <div className="mx-auto max-w-xl py-16 text-center">
      <h1 className="text-2xl font-semibold text-slate-800">Admin access required</h1>
      <p className="mt-4 text-slate-600">
        You don&apos;t have access to this admin area.
      </p>
      <Link to="/" className="mt-8 inline-block text-blue hover:underline">
        Back to home
      </Link>
    </div>
  )
}
